import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { CustomPrimeNgPreset } from './custom-primeng-preset';
import { ApiModule as ConcursoApiModule, Configuration as ConcursoConfiguration } from './features-modules/gestao-de-concurso/api';
import { ApiModule as ProfissionaisApiModule, Configuration as ProfissionaisConfiguration } from './features-modules/bolsa-de-profissionais/api';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideKeycloak, withAutoRefreshToken, AutoRefreshTokenService, UserActivityService } from 'keycloak-angular';
import { environment } from './environments/environment';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import {
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG
} from 'keycloak-angular';
function escapeForRegex(url: string): string {
  return url
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // escapa . * + ? ^ $ { } ( ) | [ ] \
    .replace(/\/+$/, '');                   // remove barras no fim
}

// const base = escapeForRegex(environment.apiBolseirosUrl);
// ^ início da string, depois o base, seguido de /, ?, ou fim de string
// const urlRegex = new RegExp(`^${base}(?:/|\\?|$)`, 'i');

const bases = [environment.apiBolseirosUrl, environment.apiProfissionaisUrl, environment.apiConcursoUrl]
  .map(escapeForRegex)
  .join('|');

const urlRegex = new RegExp(`^(${bases})(?:/|\\?|$)`, 'i');

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: urlRegex,
  bearerPrefix: 'Bearer',
});

const ptTranslation = {
  accept: 'Sim',
  reject: 'Não',
  today: 'Hoje',
  clear: 'Limpar',
  dateFormat: 'dd/mm/yy',
  dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  chooseYear: 'Ano',
  chooseMonth: 'Mês',
  chooseDate: 'Data',
  weekHeader: 'Sem'
};

export function concursoApiConfigFactory() {
  return new ConcursoConfiguration({
    basePath: environment.apiConcursoUrl,
  });
}

export function profissionsisApiConfigFactory() {
  return new ProfissionaisConfiguration({
    basePath: `${environment.apiProfissionaisUrl.replace(/\/+$/, '')}/profissionais`,
  });
}

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloakURL,
      realm: 'mirempet-auth',
      clientId: 'mirempet'
    },
    initOptions: {
      onLoad: 'login-required', // Changed this to 'login-required' to force login if not authenticated
      checkLoginIframe: false,
      redirectUri: environment.redirectUri,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 60000,
      }),
    ],
    providers: [AutoRefreshTokenService, UserActivityService]
  });

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideKeycloakAngular(),
    provideAnimationsAsync(),
    ...(ConcursoApiModule.forRoot(concursoApiConfigFactory).providers || []),
    ...(ProfissionaisApiModule.forRoot(profissionsisApiConfigFactory).providers || []),
    providePrimeNG({
      theme: {
        preset: CustomPrimeNgPreset,
      },
      ripple: true,
      translation: ptTranslation
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition] // <-- Note that multiple conditions might be added.
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([loadingInterceptor, includeBearerTokenInterceptor]))
  ]
};
